import Modal from "components/ui/modals";
import Input from "components/ui/Input";
import { useOrderHeader } from "hooks/order";

export default function LotModal({ isOpen, onClose }) {
  const { lotData, setLotData } = useOrderHeader();

  const handleInputChange = (index, field, value) => {
    const newLotData = [...lotData];
    newLotData[index] = { ...newLotData[index], [field]: value };
    setLotData(newLotData);
  };

  const handleAddLot = () => {
    const newLot = {
      caseId: '',
      lotQty: 1,
      remark: ''
    };
    setLotData([...lotData, newLot]);
  };

  const handleRemoveLot = (index) => {
    const newLotData = lotData.filter((_, i) => i !== index);
    setLotData(newLotData);
  };

  return (
    <Modal
      open={isOpen}
      setOpen={onClose}
      maxWidth="lg"
      header={
        <div>
          <h3 className="text-lg font-semibold leading-6 text-gray-900">Lot Details</h3>
          <p className="mt-0.5 text-sm text-gray-500">Manage lot information for your order.</p>
        </div>
      }
      footer={
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={onClose}
            className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            Save
          </button>
        </div>
      }
    >
      <div className="space-y-4">
        {/* Add Lot Button */}
        <div className="flex justify-between items-center">
          <span className="text-sm font-medium text-gray-900">Lots ({lotData.length})</span>
          <button
            type="button"
            onClick={handleAddLot}
            className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
          >
            <svg className="h-3 w-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Add
          </button>
        </div>

        {/* Lots List */}
        {lotData.length > 0 ? (
          <div className="space-y-3">
            {lotData.map((lot, index) => (
              <div key={index} className="bg-gray-50 rounded-md p-3 border border-gray-200">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs font-medium text-gray-700">Lot #{index + 1}</span>
                  <button
                    type="button"
                    onClick={() => handleRemoveLot(index)}
                    className="text-red-600 hover:text-red-800 p-1 hover:bg-red-50 rounded transition-colors duration-200"
                    title="Remove lot"
                  >
                    <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                <div className="grid grid-cols-2 gap-3 mb-3">
                  <div>
                    <Input
                      label="Case ID"
                      type="number"
                      value={lot.caseId}
                      onChange={(e) => handleInputChange(index, 'caseId', parseInt(e.target.value) || '')}
                      placeholder="1"
                      min="1"
                    />
                  </div>
                  <div>
                    <Input
                      label="Quantity"
                      type="number"
                      value={lot.lotQty}
                      onChange={(e) => handleInputChange(index, 'lotQty', parseInt(e.target.value) || 1)}
                      min="1"
                      placeholder="1"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">Remark</label>
                  <textarea
                    value={lot.remark}
                    onChange={(e) => handleInputChange(index, 'remark', e.target.value)}
                    className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm px-2 py-1.5 border resize-none"
                    rows="2"
                    placeholder="Optional remark..."
                  />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8 bg-gray-50 rounded-md border-2 border-dashed border-gray-300">
            <svg className="mx-auto h-8 w-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2M4 13h2m13-8V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v1M7 6V4a1 1 0 011-1h4a1 1 0 011 1v2" />
            </svg>
            <p className="mt-2 text-sm text-gray-500">No lots added yet.</p>
            <button
              type="button"
              onClick={handleAddLot}
              className="mt-3 inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Add First Lot
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
}
